/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Faq_Q1Inputs */

const en_pricing_faq_q1 = /** @type {(inputs: Pricing_Faq_Q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is there a free plan?`)
};

const de_pricing_faq_q1 = /** @type {(inputs: Pricing_Faq_Q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gibt es einen kostenlosen Plan?`)
};

const fr_pricing_faq_q1 = /** @type {(inputs: Pricing_Faq_Q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How much does Alchema cost?`)
};

const es_pricing_faq_q1 = /** @type {(inputs: Pricing_Faq_Q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How much does Alchema cost?`)
};

const it_pricing_faq_q1 = /** @type {(inputs: Pricing_Faq_Q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How much does Alchema cost?`)
};

const nl_pricing_faq_q1 = /** @type {(inputs: Pricing_Faq_Q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How much does Alchema cost?`)
};

const pl_pricing_faq_q1 = /** @type {(inputs: Pricing_Faq_Q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How much does Alchema cost?`)
};

const fi_pricing_faq_q1 = /** @type {(inputs: Pricing_Faq_Q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How much does Alchema cost?`)
};

const da_pricing_faq_q1 = /** @type {(inputs: Pricing_Faq_Q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How much does Alchema cost?`)
};

const sv_pricing_faq_q1 = /** @type {(inputs: Pricing_Faq_Q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How much does Alchema cost?`)
};

/**
* | output |
* | --- |
* | "Is there a free plan?" |
*
* @param {Pricing_Faq_Q1Inputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const pricing_faq_q1 = /** @type {((inputs?: Pricing_Faq_Q1Inputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Faq_Q1Inputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pricing_faq_q1(inputs)
	if (locale === "fr") return fr_pricing_faq_q1(inputs)
	if (locale === "es") return es_pricing_faq_q1(inputs)
	if (locale === "it") return it_pricing_faq_q1(inputs)
	if (locale === "nl") return nl_pricing_faq_q1(inputs)
	if (locale === "pl") return pl_pricing_faq_q1(inputs)
	if (locale === "fi") return fi_pricing_faq_q1(inputs)
	if (locale === "da") return da_pricing_faq_q1(inputs)
	if (locale === "sv") return sv_pricing_faq_q1(inputs)
	return en_pricing_faq_q1(inputs)
});